import ApiRouteProvider from '../route'
import axios from '@axios'

export default {
    getSystem(businessObject, primaryKey) {
        return axios.get(ApiRouteProvider.getBaseUrl() + '/changelog/system/' + businessObject + '/' + primaryKey);
    },
    get(namespace, businessObject, primaryKey) {
        return axios.get(ApiRouteProvider.getBaseUrl() + '/changelog/' + namespace + '/' + businessObject + '/' + primaryKey);
    }
};
